import Orders from '../models/Orders';
const orders = new Orders();
 
export default () => ({
  orders
});
